import React, { useState, useRef, useCallback } from "react";
import styles from "./instructions.module.scss";
import { Link } from "@reach/router";

function Instructions(props) {
  return (
    <div className={styles.page}>
      <b>
        <u>INCIDENT MARKER SCORING CRITERIA</u>
      </b>
      <p>Each Incident Marker is awarded 0-50 points</p>
      <u>A Good Marker Typically:</u>
      <ul>
        <li className={styles.tips}>
          Gives a comprehensive description of the incident and enough details
          to paint a rich picture of the situation. (0-10 points)
        </li>
        <li className={styles.tips}>
          Provides things you have collected from the real world to support
          this, eg. photos, video and audio recordings. (0-10 points)
        </li>
        <li className={styles.tips}>
          Tells a personal story from your (nonhuman) point of view that allows
          us (humans) to empathise with you. (0-10 points)
        </li>
        <li className={styles.tips}>
          Shows you have thought about how your incident could have wider
          ecological or environmental consequences. (0-10 points)
        </li>
        <li className={styles.tips}>
          Provides a clear and practical idea of what you think humans
          (especially land owning and law making humans) should do to help you.
          (0-10 points)
        </li>
      </ul>
      <u>What makes a bad marker?</u>
      <ul>
        <li className={styles.tips}>
          If descriptions are too long (and not relevant) or too short (and not
          enough detail).
        </li>
        <li className={styles.tips}>
          If it isn't clear who is speaking and it is difficult to empathise
          with.
        </li>
        <li className={styles.tips}>
          If the text is badly written, e.g. lots of spelling mistakes, or if
          sentences don't make sense.{" "}
        </li>
        <li className={styles.tips}>
          if solutions are impractical, too expensive, or unrealistic.
        </li>
      </ul>
      <br />
      <nav>
        <ul className={styles.NavList}>
          <li className={styles.links}>
            <Link className={styles.linkButton} to={"/"}>
              HOME
            </Link>
          </li>
          <li className={styles.links}>
            <Link
              className={styles.linkButton}
              to={"/credits/" + props.alpha + "/" + props.type + ""}
            >
              VIEW CREDITS
            </Link>
          </li>
          <li className={styles.links}>
            <Link
              className={styles.linkButton}
              to={"/about/" + props.alpha + "/" + props.type + ""}
            >
              ABOUT
            </Link>
          </li>
          {props.type !== "undefined" && (
            <li className={styles.links}>
              <Link
                className={styles.linkButton}
                to={"/" + props.alpha + "/" + props.type + ""}
              >
                BACK TO MAP
              </Link>
            </li>
          )}
        </ul>
      </nav>
      <br />
    </div>
  );
}

export default Instructions;
